module.exports = __webpack_public_path__ + "img/at.7fc4e220.svg";